<template>
  <div class="expir-dialog-wrap">
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title" :btnTxt="btnTxt" widthnew="450px" heightnew="520px">
      <div class="expir-bg"><img class="expir-bg-img" src="../../../../assets/imgs/expir-dialog.png"></div>
      <p class="expri-tit">尊贵的会员</p>
      <p class="expri-tit">您的会员卡已失效{{cvipMes.outdates}}天</p>
      <p class="expri-des">该功能需要续费后才可使用哦</p>
    </CvipDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CvipDialog from "./common/CvipDialog"
export default {
  name: "expirDialog",
  components: {
    CvipDialog
  },
  data () {
    return {
      title: '',
      btnTxt: "立即续费",
      expir: ''
    }
  },
  created () {
    window.clickLog && window.clickLog('from=pc-cvip-shixiao-show-new')
  },
  methods: {
    // 点击支付按钮
    vipBuy () {
      this.$emit('buyDialog')
      window.clickLog && window.clickLog('from=pc-cvip-shixiao-ljxf-new')
    },
    close () {
      this.$emit('closeDialog')
      window.clickLog && window.clickLog('from=pc-cvip-shixiao-close-new')
    }
  },
  computed: mapGetters({
    cvipMes: 'cvipMes'
  })
}
</script>

<style lang="scss">
	.expir-dialog-wrap {
		
		.tit {
			margin-top: 80px;
		}
		.expir-bg {
			width: 300px;
			height: 250px;
			margin: 30px auto 0;
			overflow: hidden;
		}
		.expir-bg-img {
			width: 300px;
			height: 250px;
		}
		.expri-tit {
			font-size: 28px;
			color: #333333;
			line-height: 34px;
			text-align: center;
		}
		.expri-des {
			margin-top: 20px;
			font-size: 14px;
			color: #999999;
			text-align: center;
		}
		.cvip-dialog-wrap .cvip-dialog .dialog-btm {
			box-shadow: none;
		}
		.cvip-dialog-wrap .cvip-dialog .dialog-btm .btn-wrap{
			margin: 0 auto;
		}
	}
</style>



// WEBPACK FOOTER //
// ExpriDialog.vue?7e5cd3fd